import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliIconSiPinned from '@blibli/blue-dls-library-icon/dist/Pinned'
import BliIconSiOpenNew from '@blibli/blue-dls-library-icon/dist/OpenNew'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import NotificationList from '@vue3/components/common/NotificationList/index.vue'
import { app } from '@vue3/configs'

export default {
  name: 'NotificationModal',
  components: {
    BliButton,
    BliModal,
    BliModalHeader,
    BliModalBody,
    BliModalFooter,
    BliIconSiPinned,
    NotificationList,
    BliIconSiOpenNew
  },
  props: {
    isModalVisible: {
      type: Boolean,
      default: false
    }
  },
  mixins: [CommonMixin],
  emits: ['closeModal'],
  methods: {
    navigateToNotificationPage () {
      this.$router.push({ name: app.routerName.notification })
      this.$emit('closeModal')
    }
  }
}
